import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { AdminAPI } from '@guestgoodie/graphql'

import { Permission, useCheckPermission } from '@/features/auth'

export function useHasUnreadOrders() {
  const canSeeOrders = useCheckPermission([Permission.ORDER_READ])

  const { data } = useQuery(AdminAPI.order.UNREAD_COUNT, {
    errorPolicy: canSeeOrders ? 'all' : 'ignore'
  })

  return useMemo(() => {
    if (!canSeeOrders) return false
    if (!data) return false

    return data.ordersUnreadCount > 0
  }, [data, canSeeOrders])
}
